<template>
  <main>
    <b-modal id="getStartedModal" size="lg" scrollable centered hide-footer title="Sign up for HelloHR!">
      <div class="modal-body" id="hubspotForm" v-once />
    </b-modal>
    <background-wrapper color="#FFEF51">
      <div class="hero">
        <b-row class="m-auto">
          <b-col cols=12 md=7 lg=6 class="p-0">
            <img class="hero__icon mb-3" :src="require(`@/assets/${routeNameKebab}/hero.svg`)"/>
            <h1>{{$t(`${$toKebabCase($route.name)}.hero.title`)}}</h1>
            <p class="h-sub pr-3" v-html="$t(`${$toKebabCase($route.name)}.hero.description`)" />
            <button class="btn btn-primary" v-b-modal.getStartedModal>{{$t(`${$toKebabCase($route.name)}.hero.btn`)}}</button>
          </b-col>
          <b-col class="circles d-none d-md-flex" md=5 lg=6>
            <div class="circle-hover">
              <img class="circle circle-one" :src="require(`@/assets/${routeNameKebab}/circle-1.png`)"/>
              <div class="overlay">
                <div class="text">
                  Being able to call a team of HR experts helps small business owner Spencer understand his legislative obligations and gives him the right tools for his growing business.
                </div>
              </div>
            </div>
            <div class="circle-hover">
              <img class="circle circle-one" :src="require(`@/assets/${routeNameKebab}/circle-2.png`)"/>
              <div class="overlay">
                <div class="text">
                  Running a nonprofit takes time and energy, and Ada saves both thanks to her team of HR experts helping her quickly deploy training and fill in compliance gaps.
                </div>
              </div>
            </div>
            <div class="circle-hover">
              <img class="circle circle-one" :src="require(`@/assets/${routeNameKebab}/circle-3.png`)"/>
              <div class="overlay">
                <div class="text">
                  Travis volunteers at a local nonprofit. Reviewing policies and completing training from anywhere takes away the hassle of administrative tasks so that he can focus on giving back to his community.
                </div>
              </div>
            </div>
            <div class="circle-hover d-none d-lg-block">
              <img class="circle circle-one" :src="require(`@/assets/${routeNameKebab}/circle-4.png`)"/>
            </div>
          </b-col>
        </b-row>
      </div>
    </background-wrapper>
    <awards :margin="false"/>
    <background-wrapper image="linear-gradient(to bottom, #FFF 30%, #EDFFE8 60%, #FFF 80%)">
      <background-wrapper :src="routeNameKebab + '/hire'" ext="png" align="top">
        <div class="hire">
          <div class="text-center">
            <h2 class="h1 hire__title">Compliance is your primary concern and our <span class='no-break-text'>area of expertise.</span></h2>
            <b-btn variant="primary" v-b-modal.getStartedModal>{{$t('get-started')}}</b-btn>
          </div>
          <div class="window">
            <div class="hire-title d-block d-lg-none">Hire your own HR team, click to learn more!</div>
            <div class="card-wrapper">
              <div class="preview-card">
                <div class="title">Upload your HR documents</div>
                <div class="popover-wrapper" :class="{'active': hirePopUp.upload}" @click="showHire('upload')">
                  <span class="learn">Learn more!</span>
                  <div class="popover-content">
                    <button type="button" class="close popover-close" aria-label="Close">
                      <span aria-hidden="true">×</span>
                    </button>
                    <p class="popover-title">Upload your HR documents</p>
                    <p class="popover-description">Upload your documents for a compliance review. Your team of dedicated HR experts ensures that you have achieved legislative compliance.</p>
                    <button class="btn btn-primary" v-b-modal.getStartedModal>Get started!</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-wrapper">
              <div class="preview-card">
                <div class="title">Partner with our HR experts</div>
                <div class="popover-wrapper" :class="{'active': hirePopUp.partner}" @click="showHire('partner')">
                  <span class="learn">Learn more!</span>
                  <div class="popover-content">
                    <button type="button" class="close popover-close" aria-label="Close">
                      <span aria-hidden="true">×</span>
                    </button>
                    <p class="popover-title">Partner with our HR experts</p>
                    <p class="popover-description">Partner with our team of HR experts to help you on your path to compliance. They are available to help you understand legislative requirements and provide you direction on establishing your HR practices.</p>
                    <button class="btn btn-primary" v-b-modal.getStartedModal>Get started!</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-wrapper">
              <div class="preview-card">
                <div class="title">Unlimited HR documents</div>
                <div class="popover-wrapper" :class="{'active': hirePopUp.unlim}" @click="showHire('unlim')">
                  <span class="learn">Learn more!</span>
                  <div class="popover-content">
                    <button type="button" class="close popover-close" aria-label="Close">
                      <span aria-hidden="true">×</span>
                    </button>
                    <p class="popover-title">Unlimited HR documents</p>
                    <p class="popover-description">Request unlimited HR policies and documents to help you build a solid foundation for your business.</p>
                    <button class="btn btn-primary" v-b-modal.getStartedModal>Get started!</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="hire-title d-none d-lg-block">Hire your own HR team, click to learn more!</div>
            <div class="card-wrapper">
              <div class="preview-card">
                <div class="title">Monthly HR‑focused webinars</div>
                <div class="popover-wrapper" :class="{'active': hirePopUp.webinar}" @click="showHire('webinar')">
                  <span class="learn">Learn more!</span>
                  <div class="popover-content">
                    <button type="button" class="close popover-close" aria-label="Close">
                      <span aria-hidden="true">×</span>
                    </button>
                    <p class="popover-title">Monthly HR‑focused webinars</p>
                    <p class="popover-description">Attend monthly webinars focussed on trending and key legislation topics with practical tips and strategies to adopt.</p>
                    <button class="btn btn-primary" v-b-modal.getStartedModal>Get started!</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-wrapper">
              <div class="preview-card">
                <div class="title">Customized HR compliance plan</div>
                <div class="popover-wrapper" :class="{'active': hirePopUp.plan}" @click="showHire('plan')">
                  <span class="learn">Learn more!</span>
                  <div class="popover-content">
                    <button type="button" class="close popover-close" aria-label="Close">
                      <span aria-hidden="true">×</span>
                    </button>
                    <p class="popover-title">Customized HR compliance plan</p>
                    <p class="popover-description">Partner with our HR team to craft a business plan customized for your organization's short- and long-term goals. We create a blueprint for you to implement and provide support along the way.</p>
                    <button class="btn btn-primary" v-b-modal.getStartedModal>Get started!</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-wrapper">
              <div class="preview-card">
                <div class="title">Unlimited core legislative training</div>
                <div class="popover-wrapper" :class="{'active': hirePopUp.training}" @click="showHire('training')">
                  <span class="learn">Learn more!</span>
                  <div class="popover-content">
                    <button type="button" class="close popover-close" aria-label="Close">
                      <span aria-hidden="true">×</span>
                    </button>
                    <p class="popover-title">Unlimited core legislative training</p>
                    <p class="popover-description">Our team of HR experts builds you a customized core legislative training bundle for your employees. We take care of sending out and tracking individual participation, providing you updates along the way, so that you can breathe easier knowing required training has been completed.</p>
                    <button class="btn btn-primary" v-b-modal.getStartedModal>Get started!</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="background-images">
              <img class="cloud top-left d-none d-lg-block" src="@/assets/hellohr/cloud.png"/>
              <img class="cloud bottom-left" src="@/assets/hellohr/cloud.png"/>
              <img class="cloud top-right d-none d-lg-block" src="@/assets/hellohr/cloud.png"/>
              <img class="cloud bottom-right" src="@/assets/hellohr/cloud.png"/>
              <img class="tree-left d-none d-lg-block" src="@/assets/hellohr/tree-left.svg"/>
              <img class="fern" src="@/assets/hellohr/fern.png"/>
              <img class="goat" alt="Goat telling employers HelloHR starts at $99 per month" src="@/assets/hellohr/goat.png"/>
              <img class="tree-right d-none d-lg-block" src="@/assets/hellohr/tree-right.png"/>
            </div>
          </div>
        </div>
      </background-wrapper>
      <div class="experts">
        <h1 class="experts__title h1" v-html="$t(`${$toKebabCase($route.name)}.expert.title`)" />
        <div class="computer-bg">
          <img class="computer-screen d-none d-xl-block" src="@/assets/hellohr/computer.png">
          <img class="computer-screen d-block d-xl-none" src="@/assets/hellohr/computer-sm.png">
          <VueSlickCarousel :arrows="true" v-bind="settings" class="slider">
            <div v-for="n in 10" :key="n">
              <div class="expert">
                <div class="expert__img">
                  <img :src="require(`@/assets/${routeNameKebab}/${n}.png`)"/>
                </div>
                <div class="expert__info">
                  <div class="expert__title">{{$t(`${$toKebabCase($route.name)}.expert.personal-title`)}}</div>
                  <div class="expert__name">{{$t(`${$toKebabCase($route.name)}.expert.personal.${n}.name`)}}</div>
                  <div class="expert__position">{{$t(`${$toKebabCase($route.name)}.expert.personal.${n}.position`)}}</div>
                </div>
              </div>
            </div>
            <template #prevArrow>
              <div class="custom-arrow">
                <img src="@/assets/arrow-left.svg">
              </div>
            </template>
            <template #nextArrow>
              <div class="custom-arrow">
                <img src="@/assets/arrow-right.svg">
              </div>
            </template>
          </VueSlickCarousel>
          <h1 class="we-do-hr">We do HR so you can do what you love!</h1>
        </div>
        <img class="tree-owl d-none d-xl-block" src="@/assets/hellohr/tree-owl.svg">
      </div>
    </background-wrapper>
    <awards :margin="false"/>
    <background-wrapper image="linear-gradient(#80C7FF, #fff)">
      <div class="pricing">
        <h1 class="h1">Pricing</h1>
        <div class="container-fluid">
          <div class="row">
            <b-col class="card-container">
              <div class="card">
                <div class="header">
                  <div class="range">1-19 Employees</div>
                  <div class="price">
                    <span class="dollar">$</span>
                    <span class="cost">99</span>
                    <span class="month">/month</span>
                  </div>
                  <div class="billed">Billed annually at $<strong>1,188</strong></div>
                </div>
                <div class="card-body">
                  <ul>
                    <li><strong>UNLIMITED</strong> HR Documents</li>
                    <li><strong>UNLIMITED</strong> Core Legislative Employee Training</li>
                    <li><strong>A TEAM</strong> of HR Experts to support your business!</li>
                    <li>Customized HR compliance plan that fits <strong>YOUR</strong> business.</li>
                  </ul>
                </div>
              </div>
            </b-col>
            <b-col class="card-container">
              <div class="card">
                <div class="header">
                  <div class="range">20-50 Employees</div>
                  <div class="price">
                    <span class="dollar">$</span>
                    <span class="cost">165</span>
                    <span class="month">/month</span>
                  </div>
                  <div class="billed">Billed annually at $<strong>1,980</strong></div>
                </div>
                <div class="card-body">
                  <ul>
                    <li><strong>UNLIMITED</strong> HR Documents</li>
                    <li><strong>UNLIMITED</strong> Core Legislative Employee Training</li>
                    <li><strong>A TEAM</strong> of HR Experts to support your business!</li>
                    <li>Customized HR compliance plan that fits <strong>YOUR</strong> business.</li>
                  </ul>
                </div>
              </div>
            </b-col>
            <b-col class="card-container">
              <div class="card">
                <div class="header">
                  <div class="range">51-100 Employees</div>
                  <div class="price">
                    <span class="dollar">$</span>
                    <span class="cost">250</span>
                    <span class="month">/month</span>
                  </div>
                  <div class="billed">Billed annually at $<strong>3,000</strong></div>
                </div>
                <div class="card-body">
                  <ul>
                    <li><strong>UNLIMITED</strong> HR Documents</li>
                    <li><strong>UNLIMITED</strong> Core Legislative Employee Training</li>
                    <li><strong>A TEAM</strong> of HR Experts to support your business!</li>
                    <li>Customized HR compliance plan that fits <strong>YOUR</strong> business.</li>
                  </ul>
                </div>
              </div>
            </b-col>
            <b-col class="card-container">
              <div class="card">
                <div class="header">
                  <div class="range">100+ Employees</div>
                  <div class="price">
                    <button class="btn btn-primary" v-b-modal.getStartedModal>Request a Quote</button>
                  </div>
                  <div class="billed">Connect with us for pricing</div>
                </div>
                <div class="card-body">
                  <ul>
                    <li><strong>UNLIMITED</strong> HR Documents</li>
                    <li><strong>UNLIMITED</strong> Core Legislative Employee Training</li>
                    <li><strong>A TEAM</strong> of HR Experts to support your business!</li>
                    <li>Customized HR compliance plan that fits <strong>YOUR</strong> business.</li>
                  </ul>
                </div>
              </div>
            </b-col>
          </div>
        </div>
      </div>
    </background-wrapper>
    <background-wrapper :image="'url('+require(`@/assets/${routeNameKebab}/blob.png`)+')'" size="100%" align="leftBottom" class="pb-5">
      <div class="team">
        <h1 class="center">Hire Our Team of Expert HR Specialists</h1>
        <h2 class="center">With knowledge and experience in all areas of HR, including:</h2>
        <img class="w-100 mb-5" :src="require(`@/assets/${routeNameKebab}/team.png`)"/>
        <button class="d-block btn btn-primary m-auto" v-b-modal.getStartedModal>Get started!</button>
        <div class="card shadow-sm mt-5">
          <div class="card-body">
            <div class="text">
              <h3 class="title">Get HelloHR today!</h3>
              <p>Please fill in the application to get started, and we'll contact you.</p>
              <p><strong>Need immediate help?</strong> Contact Consulting Services directly at: 877.438.9763 x 9</p>
              <button class="btn btn-primary card-button" v-b-modal.getStartedModal>Get started!</button>
            </div>
            <div class="image">
              <img alt="HRdownloads’ tagine 'Love What You Do' with illustrated people sitting on some of the letters" :src="require(`@/assets/love-what-you-do.png`)"/>
            </div>
          </div>
        </div>
      </div>
    </background-wrapper>
  </main>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import { Awards } from '@/components/ui/products'

export default {
  name: 'HelloHr',
  data () {
    return {
      hirePopUp: {
        upload: false,
        partner: false,
        unlim: false,
        webinar: false,
        plan: false,
        training: false
      },
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 1000
      },
      getStarted: false
    }
  },
  components: { VueSlickCarousel, Awards },
  methods: {
    showHire (i) {
      this.hirePopUp[i] = !this.hirePopUp[i]
    },
    handleGetStarted () {
      this.getStarted = !this.getStarted
    }
  },
  computed: {
    routeNameKebab: app => app.$toKebabCase(app.$route.name)
  },
  mounted () {
    if (!document.getElementById('hello-hr-form-script')) {
      const script = document.createElement('script')
      script.src = 'https://js.hsforms.net/forms/v2.js'
      script.id = 'hello-hr-form-script'
      document.body.appendChild(script)
      script.addEventListener('load', () => {
        this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
          console.log(window.hbspt.forms)
          if (window.hbspt) {
            window.hbspt.forms.create({
              region: 'na1',
              portalId: '1890515',
              formId: '683a6d48-541d-44a5-acbe-534d48520a43',
              sfdcCampaignId: '7010A000000JPHYQA4',
              target: '#hubspotForm'
            })
          }
        })
      })
    }
  }
}
</script>

<style lang="sass" scoped>
.modal
  display: block
  overflow-x: hidden
  overflow-y: auto
  position: fixed
  top: 0
  left: 0
  z-index: 1050
  width: 100%
  height: 100%
  outline: 0
  .modal-body
    padding: 2rem 1rem
  .modal-header
    background: #1e4f85
    color: white
    padding: 2rem 1rem
    -webkit-box-pack: center
    justify-content: center
    .close
      color: white
      opacity: 1
      font-size: 34px
      position: absolute
      right: 2rem
    .modal-title
      font-size: 24px
      font-weight: 700
  .modal-body
    padding: 2rem 1rem

.center
  text-align: center

.award-wrapper
  z-index: 2!important

.custom-arrow
  color: $dark
  font-size: 14px
  height: 29px
  &:before
    content: none

  &.slick-prev
    left: 10px

  &.slick-next
    right: 10px

.hero
  padding: 100px 0
  background-image: url("~@/assets/hellohr/yellow-left.png"), url("~@/assets/hellohr/yellow-right.png"), linear-gradient(#FFFADC, #FFFADC)
  background-position: left, right
  background-repeat: no-repeat
  background-size: contain
  +media-breakpoint-down(sm)
    background-position: left 20px center, right -110px center
  +media-breakpoint-down(xs)
    background-size: cover

.hero-circle
  position: absolute
  max-width: 190px
  max-height: 190px
  border-radius: 50%
  opacity: 0
  transition: .5s ease
  background-color: #41327d
  .text
    color: #fff
    font-size: 12px
    line-height: 16px
    position: absolute
    top: 50%
    left: 50%
    -webkit-transform: translate(-50%, -50%)
    transform: translate(-50%, -50%)
    text-align: left
    width: 140px

.circles
  align-self: stretch
  padding: 20px 0
  +media-breakpoint-down(lg)
    margin-left: -50px
  +media-breakpoint-down(md)
    flex-direction: column
    padding: 0
    margin-left: 0

  .circle
    max-width: 190px
    max-height: 190px
    +media-breakpoint-down(md)
      max-width: 125px
      max-height: 125px

  .circle-hover
    position: relative
    outline: none
    &:nth-of-type(odd)
      align-self: flex-start
      +media-breakpoint-down(md)
        margin-left: 40px

    &:nth-of-type(even)
      align-self: flex-end

    &:not(:last-of-type)
      cursor: pointer

    &:not(:nth-of-type(3))
      +media-breakpoint-down(md)
        margin-bottom: -40px

  .circle-hover:hover .overlay,
  .circle-hover:focus-visible .overlay
    opacity: 1
    +media-breakpoint-down(md)
      opacity: 0

  .overlay
    position: absolute
    top: 0
    bottom: 0
    left: 0
    right: 0
    max-width: 190px
    max-height: 190px
    border-radius: 50%
    opacity: 0
    transition: .5s ease
    background-color: rgba(66, 51, 126, 0.95)

  .text
    color: white
    font-size: 12px
    line-height: 16px
    position: absolute
    top: 50%
    left: 50%
    -webkit-transform: translate(-50%, -50%)
    transform: translate(-50%, -50%)
    text-align: left
    width: 140px

.hire
  position: relative
  width: 100%

  &__title
    margin: auto
    padding: 160px 0 45px
    max-width: 800px

  &-title
    grid-column-start: 1
    grid-column-end: 4
    font-size: 32px
    font-weight: 900
    text-align: center
    padding: 50px 0
    +media-breakpoint-down(lg)
      padding: 30px 0
    +media-breakpoint-down(md)
      grid-column-end: 3
      padding: 0 0 50px
      max-width: 400px
      margin: auto
    +media-breakpoint-down(sm)
      padding-bottom: 20px
    +media-breakpoint-down(xs)
      grid-column-end: 2
      padding-bottom: 0

  .window
    display: grid
    grid-template-columns: repeat(3, 1fr)
    gap: 0 50px
    margin: 220px 0 400px
    padding: 80px 50px
    width: 100%
    position: relative
    border-radius: 30px
    background: #cce9ff
    background-image: linear-gradient(to bottom right, #B6E6FF 50%, #7FC9FF)
    box-shadow: 0px 0px 0px 2px #b7b7b7, 0px 0px 0px 22px #eeeeee, 0px 0px 0px 24px #b7b7b7, 0px 0px 0px 25px #d2d2d2, 0px 0px 0px 26px #b7b7b7
    +media-breakpoint-down(lg)
      gap: 30px
      padding: 80px 30px
    +media-breakpoint-down(md)
      grid-template-columns: repeat(2, 1fr)
      gap: 30px
      padding: 60px 30px 230px
      margin: 180px 0 160px
    +media-breakpoint-down(xs)
      grid-template-columns: repeat(1, 1fr)
      gap: 30px
      padding: 40px 20px 230px

  .card-wrapper
    display: flex
    align-items: center
    justify-content: center

  .preview-card
    display: flex
    flex-direction: column
    justify-content: space-between
    padding: 20px
    width: 100%
    height: 100%
    border: 2px solid #80c1ff
    background: #fff
    border-radius: 15px
    text-align: center
    +media-breakpoint-down(lg)
      padding: 15px
    +media-breakpoint-down(sm)
      padding: 10px

    .title
      font-size: 24px
      font-weight: 900
      color: #42337e
      margin-bottom: 10px
      +media-breakpoint-down(sm)
        font-size: 20px

    .popover-wrapper.active .popover-content
      z-index: 10
      opacity: 1
      visibility: visible
      -webkit-transform: translate(0, -30px)
      transform: translate(0, -30px)
      transition: all 0.5s cubic-bezier(0.75, -0.02, 0.2, 0.97)

    .popover-wrapper
      position: relative
      display: inline-block
      outline: none

      .learn
        padding: 5px
        cursor: pointer
        color: #0072E0
        font-weight: 600

      .popover-content
        opacity: 0
        visibility: hidden
        position: absolute
        right: -215px
        -webkit-transform: translate(0, 0)
        transform: translate(0, 0)
        background-color: #fff
        border: 2px solid #80c1ff
        padding: 20px
        box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26)
        width: auto
        border-radius: 5px
        display: -webkit-box
        display: flex
        -webkit-box-orient: vertical
        -webkit-box-direction: normal
        flex-direction: column
        +media-breakpoint-down(lg)
          left: -20px
          right: -75px !important
          transform: translate(0, -20px)
        +media-breakpoint-down(md)
          left: 0
        +media-breakpoint-down(sm)
          left: -40px
        +media-breakpoint-down(xs)
          right: -40px !important
          transform: translate(0, -70px)

        .popover-close
          position: absolute
          width: unset
          height: unset
          top: 5px
          right: 10px
          outline: none

        .popover-title
          font-size: 32px
          font-weight: 900
          line-height: 36px
          color: #42337E
          margin: 0 auto
          max-width: 290px

        .popover-description
          font-size: 18px
          line-height: 22px
          text-align: left
          margin: 0
          max-width: 270px
          padding: 20px 0
          +media-breakpoint-down(xs)
            max-width: unset

  .background-images img
    pointer-events: none
    user-select: none

  .cloud
    max-width: 470px
    position: absolute
    +media-breakpoint-down(md)
      max-width: 400px
    +media-breakpoint-down(xs)
      max-width: 300px

    &.top-left
      top: -100%
      left: -40%

    &.bottom-left
      top: -31%
      left: -31%
      +media-breakpoint-down(md)
        top: -11%
        left: -20%
      +media-breakpoint-down(sm)
        top: -18%
        left: -40%
      +media-breakpoint-down(xs)
        top: -10%

    &.top-right
      right: -35%
      top: -60%

    &.bottom-right
      right: -13%
      top: -30%
      +media-breakpoint-down(md)
        right: -30%
        top: 4%
      +media-breakpoint-down(sm)
        right: -55%
        top: 0
      +media-breakpoint-down(xs)
        right: -60%
        top: -6%

  .tree-left
    position: absolute
    top: 8%
    left: -40%
    +media-breakpoint-down(md)
      left: -47%

  .fern
    position: absolute
    top: 52%
    left: -34%
    +media-breakpoint-down(lg)
      left: -40%
    +media-breakpoint-down(md)
      left: auto
      right: -31%
      top: 72%
      transform: rotate(-10deg)
    +media-breakpoint-down(sm)
      max-width: 450px
      right: -40%
      top: 67%
    +media-breakpoint-down(xs)
      max-width: 400px
      right: -45%
      top: 80%

  .goat
    max-width: 460px
    position: absolute
    top: 77%
    left: -13%
    +media-breakpoint-down(md)
      max-width: 320px
      top: 73%
    +media-breakpoint-down(sm)
      max-width: 320px
      top: 73%
    +media-breakpoint-down(xs)
      top: 82%

  .tree-right
    position: absolute
    right: -40%
    top: 10%
    +media-breakpoint-down(lg)
      right: -48%

.experts
  display: grid

  &__title
    max-width: 800px
    margin: 50px auto 0
    +media-breakpoint-down(md)
      text-align: center
    +media-breakpoint-down(xs)
      margin: 50px auto 0
      padding: 0 15px
      max-width: 350px

  .computer-bg
    position: relative
    +media-breakpoint-down(lg)
      margin-top: 80px

  .computer-screen
    pointer-events: none
    user-select: none
    position: relative
    top: 0
    left: 50%
    transform: translateX(-50%)
    margin-left: 80px
    +media-breakpoint-down(lg)
      left: auto
      transform: unset
      margin-left: -2px
      width: 100%

  .slider
    position: absolute
    top: 150px
    left: 50%
    transform: translateX(-50%)
    width: 970px
    height: 562px
    +media-breakpoint-down(lg)
      top: 42px
      width: 818px
      height: 472px
    +media-breakpoint-down(md)
      top: 34px
      width: 610px
      height: 350px
    +media-breakpoint-down(sm)
      padding: 0 5.8%
      top: 26px
      width: 660px
      max-width: 100%
      height: 46%
    +media-breakpoint-down(xs)
      width: 100%
      height: 48vw
      top: 4%

    .slick-prev
      left: 10px
      +media-breakpoint-down(sm)
        left: 40px

    .slick-next
      right: 10px
      +media-breakpoint-down(sm)
        right: 40px

  .we-do-hr
    margin: 30px auto 120px;
    max-width: 800px
    +media-breakpoint-down(md)
      margin-bottom: 70px
      text-align: center
    +media-breakpoint-down(xs)
      padding: 0 15px
      max-width: 350px

  .tree-owl
    pointer-events: none
    user-select: none
    position: absolute
    bottom: -5%
    left: -31%

.expert
  display: flex
  align-items: center
  justify-content: center
  padding: 0 50px
  height: 562px
  +media-breakpoint-down(lg)
    height: 472px
  +media-breakpoint-down(md)
    height: 350px
  +media-breakpoint-down(sm)
    height: 340px
  +media-breakpoint-down(xs)
    padding: 0 30px
    height: 48vw

  &__img
    flex: 0 0 55%

    img
      max-width: 100%

  &__info
    flex: 0 0 45%
    max-width: 45%

  &__title
    color: #42337E
    font-size: 42px
    font-weight: 900
    letter-spacing: 0.7px
    +media-breakpoint-down(md)
      font-size: 32px
    +media-breakpoint-down(xs)
      font-size: 18px

  &__name
    color: #28292B
    font-size: 42px
    font-weight: 900
    letter-spacing: 0.7px
    +media-breakpoint-down(md)
      font-size: 24px
    +media-breakpoint-down(xs)
      font-size: 16px

  &__position
    color: #666B75
    font-size: 16px
    font-weight: bold
    letter-spacing: 1.07px
    +media-breakpoint-down(md)
      font-size: 12px
    +media-breakpoint-down(xs)
      font-size: 10px

.pricing
  padding: 100px 0 120px

  h1
    text-align: center
    margin-bottom: 30px

  .container-fluid
    +media-breakpoint-down(lg)
      max-width: 900px

  .row
    gap: 5px
    justify-content: center
    +media-breakpoint-down(lg)
      gap: 20px 5px

  .card-container
    padding: 0
    max-width: 290px
    +media-breakpoint-down(lg)
      max-width: 300px

    .card
      width: 290px
      position: relative
      display: flex
      flex-direction: column
      min-width: 0
      word-wrap: break-word
      background-color: #fff
      background-clip: border-box
      border: 1px solid rgba(0, 0, 0, .125)
      border-radius: .25rem
      +media-breakpoint-down(lg)
        width: 300px

      .header
        .range
          padding: 20px 0
          font-size: 30px
          font-weight: 900
          background: #FFED6B
          text-align: center
          white-space: nowrap
        .price
          padding: 12px 0
          background: rgba(255, 237, 107, 0.25)
          display: -webkit-box
          display: flex
          align-items: center
          justify-content: center
          height: 80px
          .dollar
            font-size: 24px
            align-self: flex-start
          .cost
            font-size: 53px
            font-weight: 900
            line-height: 1
            margin: 0 3px
          .month
            font-size: 24px
            font-weight: 900
            align-self: flex-end
        .billed
          padding: 18px 10px
          margin: 0 1.25rem
          border-bottom: 1px solid #B7B7B7
      .card-body
        padding: 15px 0
        ul
          padding: 0 50px
          margin: 0
          li
            margin-bottom: 10px

.team
  padding: 50px 0

  .card-body
    display: -webkit-box
    display: flex
    -webkit-box-align: center
    align-items: center
    padding: 60px 40px
    text-align: left
    +media-breakpoint-down(md)
      flex-direction: column
      justify-content: flex-start
      align-items: flex-start

    div
      -webkit-box-flex: 0
      flex: 0 0 50%

  +media-breakpoint-down(md)
    .card-button
      margin-bottom: 30px

  .image
    display: flex
    -webkit-box-pack: end
    justify-content: flex-end
    width: 100%
    img
      max-width: 100%
      width: 90%
</style>



// WEBPACK FOOTER //
// src/components/helloHr/HelloHr.vue